{{if level == 1}}
<div class="comment-head">
    <img src="{{img}}" alt="">
</div>
{{/if}}
<div class="dynamin-list {{if level == 2}} second-level-comment {{else if level == 3}} three-level-comment {{/if}}">
    <input type="text" class="comment-text-skin _commentTextInput" maxlength="1000">
    <button class="comment-button-skin _commentBtn" data-level="{{level}}" data-pid="{{pid}}" data-type="{{type}}">评论</button>
</div>